
import React from 'react';
import { Button } from '../../../components/base/Button';

export const HeroSection: React.FC = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contato');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToServices = () => {
    const element = document.getElementById('servicos');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Video Background */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src="https://public.readdy.ai/ai/video_res/f20dd53e-334b-4d29-8df4-961cbc4290ea.mp4" type="video/mp4" />
      </video>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#1A3A52]/90 to-[#00A896]/70"></div>

      <div className="relative w-full px-4 sm:px-6 lg:px-8 z-10">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="text-white">
              <h2 className="text-5xl lg:text-6xl font-bold mb-6 font-['Playfair_Display'] leading-tight">
                Strategic Accounting for Your Business
                <span className="text-[#C9A961]"> Growth</span>
              </h2>
              <p className="text-xl lg:text-2xl mb-8 text-gray-100 leading-relaxed">
                Over 18 years simplifying accounting and tax management for companies in Curitiba
              </p>

              <div className="flex flex-col sm:flex-row gap-4 mb-12">
                <Button
                  variant="primary"
                  size="lg"
                  onClick={scrollToContact}
                  className="bg-[#C9A961] hover:bg-[#B8984F] text-[#1A3A52] font-semibold whitespace-nowrap"
                >
                  <i className="ri-phone-line mr-2"></i>
                  Talk to a Specialist
                </Button>
                <Button
                  variant="outline"
                  size="lg"
                  onClick={scrollToServices}
                  className="border-white text-white hover:bg-white hover:text-[#1A3A52] whitespace-nowrap"
                >
                  <i className="ri-service-line mr-2"></i>
                  Discover Our Services
                </Button>
              </div>

              {/* Trust Indicators */}
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-[#C9A961] rounded-full flex items-center justify-center mr-4">
                    <i className="ri-shield-check-line text-[#1A3A52] text-xl"></i>
                  </div>
                  <div>
                    <div className="font-semibold">Active CRC/PR</div>
                    <div className="text-sm text-gray-200">Professional Registration</div>
                  </div>
                </div>

                <div className="flex items-center">
                  <div className="w-12 h-12 bg-[#C9A961] rounded-full flex items-center justify-center mr-4">
                    <i className="ri-building-line text-[#1A3A52] text-xl"></i>
                  </div>
                  <div>
                    <div className="font-semibold">500+ Companies</div>
                    <div className="text-sm text-gray-200">Served</div>
                  </div>
                </div>

                <div className="flex items-center">
                  <div className="w-12 h-12 bg-[#C9A961] rounded-full flex items-center justify-center mr-4">
                    <i className="ri-customer-service-2-line text-[#1A3A52] text-xl"></i>
                  </div>
                  <div>
                    <div className="font-semibold">Support</div>
                    <div className="text-sm text-gray-200">Specialized</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
